import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './demand_control_edit.routes';
import SaConfigService from '../../../../components/api/sa_config/sa_config.service';
import DemandLevelService from '../../../../components/api/demand_level/demand_level.service';

export class OemDemandControlEditController {
  /*@ngInject*/
  constructor($state, $stateParams, $mdDialog, SaConfigService, DemandLevelService) {
    this.id = $stateParams.id;

    this.$mdDialog = $mdDialog;
    this.$state = $state;
    this.SaConfigService    = SaConfigService;
    this.DemandLevelService = DemandLevelService;

    this.dialog = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose:true,
        title: '制御レベルを変更しますか？',
        ok: '変更する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose:true,
        title: '制御レベルを変更しました',
        ok: 'OK'
      }),
      error: $mdDialog.alert({
        clickOutsideToClose:true,
        title: 'エラーが発生しました',
        content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
        ok: 'OK'
      })
    };
  }

  $onInit() {
    this.SaConfigService.oem_api.show({ id: this.id }, response => {
      this.device = response;
    }, err => {
      if(err.status === 404 || err.status === 403) { this.$state.go('oem_main.oem_home'); }
    });

    this.DemandLevelService.oem_api.show({ id: this.id }, response => {
      this.demandLevel = this.currentLevel = response.level + '';
    });
  }

  setLevel(ev) {
    this.$mdDialog.show(this.dialog.confirm.targetEvent(ev))
      .then(() => {
        this.DemandLevelService.oem_api.update(
          { id: this.id, level: this.demandLevel },
          response => {
            this.currentLevel = this.demandLevel;
            this.$mdDialog.show(this.dialog.success);
          },
          error => { this.$mdDialog.show(this.dialog.error); }
        );
      });
  }
}

export default angular.module('leptonApp.oemDemandControlEdit', [uiRouter, SaConfigService, DemandLevelService])
  .config(routing)
  .component('oemDemandControlEdit', {
    template: require('./demand_control_edit.html'),
    controller: OemDemandControlEditController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/oem/demand_control/edit/demand_control_edit.component.js